import {
  ChartPieIcon,
  CircleDashedIcon,
  DatabaseIcon,
  FolderSearchIcon,
  HouseIcon,
  ImagePlayIcon,
  LayoutDashboardIcon,
  ScanEyeIcon,
  ShieldIcon,
  SparklesIcon,
  SquareChartGanttIcon,
  VideoIcon,
  type LucideIcon,
} from 'lucide-react';
import {
  AGENTS_PAGE,
  ALARMS_PAGE,
  CLIPS_PAGE,
  DASHBOARD_PAGE,
  DATA_EXPLORER_PAGE,
  DATA_EXPLORER_VERIFEYE_PAGE,
  DATASETS_PAGE,
  DISCOVER_PAGE,
  EVENTS_PAGE,
  INVESTIGATIONS_PAGE,
  VERIFEYE4_PAGE,
  VIDEO_PAGE,
} from 'vd-constants';

/**
 * Lucide icons for the sidebar, keyed by the nav item's page constant.
 *
 * The redesign moved from MDI to Lucide. This map is scoped to the new sidebar
 * so the legacy nav keeps rendering its existing MDI icons untouched.
 */
const NAV_ICONS: Record<string, LucideIcon> = {
  [DASHBOARD_PAGE]: HouseIcon,
  [DATA_EXPLORER_PAGE]: ChartPieIcon,
  [DATA_EXPLORER_VERIFEYE_PAGE]: ScanEyeIcon,
  [VERIFEYE4_PAGE]: ScanEyeIcon,
  [DISCOVER_PAGE]: LayoutDashboardIcon,
  [EVENTS_PAGE]: SquareChartGanttIcon,
  [VIDEO_PAGE]: VideoIcon,
  [ALARMS_PAGE]: ShieldIcon,
  [CLIPS_PAGE]: ImagePlayIcon,
  // Figma Investigations glyph is folder-search.
  [INVESTIGATIONS_PAGE]: FolderSearchIcon,
  [AGENTS_PAGE]: SparklesIcon,
  [DATASETS_PAGE]: DatabaseIcon,
};

/** Falls back to a neutral glyph so an unmapped page still renders an item. */
export function getNavIcon(page: string): LucideIcon {
  return NAV_ICONS[page] ?? CircleDashedIcon;
}
